<template lang="pug">
  .announcement
    .background-header.white
      v-container.white(style="max-width:600px")
        div
          v-layout
            h2.ml-2 Announcement
          v-layout.my-2
              v-text-field(v-model="searchText" prepend-inner-icon="mdi-email-search-outline" label='Search announcement' hide-details dense rounded outlined)
    v-container.py-0(style="max-width:600px")
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .content-layout(v-else)
        v-layout.my-6(v-if="announcements.length == 0")
          v-row.fill-height.ma-0(align='center' justify='center')
            div.mx-auto
              v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
              p.caption No item found in announcement or empty
        div(v-else)
          v-list.secondary
            v-list-item-group
              v-card.my-1(v-for="announcement in announcements" outlined :key="announcement.id")
                v-list-item(:class="announcement.read ? 'secondary' : 'white'" @click="openAnnouncementDialog(announcement)")
                  v-list-item-content
                    v-list-item-title.mb-2(v-text="announcement.title" :class="announcement.read ? '' : 'font-weight-black'")
                    v-list-item-subtitle(v-text="htmlConvert(announcement.content)")
      div.mx-1.mt-4
        v-pagination(v-if="totalPage >= 2" v-model="page" :length="totalPage" :total-visible="6")
    .modals
      show-announcement(v-if="showAnnouncement" :open.sync="showAnnouncement" :announcement.sync="announcementData" :company.sync="this.company" @refresh="fetchAnnouncement")
</template>

<script>
import { mapActions } from 'vuex'
import ShowAnnouncement from '@/components/dialogs/ShowAnnouncement.vue'

export default {
  name: 'Announcement',
  components: { ShowAnnouncement },
  props: ['company'],
  data: () =>  ({
    isFetching: true,
    searchText: '',
    announcements: [],
    totalPage: '',
    page: 1,
    fetchCount: 15,
    showAnnouncement: false,
    announcementData: {},
    searchCountDown: null
  }),
  computed: {
    authMember () {
      return this.$store.state.user.member
    },
  },
  watch: {
    page () {
      if (!this.isFetching) {
        if (this.searchText) {
          this.searchItem()
        } else {
          this.fetchAnnouncement()
        }
      }
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.page = 1
        this.searchItem()
      }, 500)
    },
  },
  mounted () {
    this.fetchAnnouncement()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchAnnouncement () {
      this.$axios.get(`/announcements/?company=${this.company.id}&page=${this.page}&page_size=${this.fetchCount}&ordering=-published_at`)
      .then(resp => {
        this.announcements = resp.data.results
        const totalCount = resp.data.count
        if (totalCount % this.fetchCount == 0) {
          this.totalPage = totalCount/this.fetchCount
        } else {
          this.totalPage = totalCount/this.fetchCount + 1
        }
        this.totalPage = parseInt(this.totalPage)
        this.isFetching = false
      })
      .catch(() => {})
    },
    htmlConvert (html) {
      let tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    },
    openAnnouncementDialog (ann) {
      this.announcementData = {...ann}
      this.showAnnouncement = true
    },
    searchItem () {
      this.isFetching = true
      this.$axios.get(`/announcements/?company=${this.company.id}&page=${this.page}&page_size=${this.fetchCount}&ordering=-published_at&search=${this.searchText}`)
        .then((resp) => {
          this.announcements = resp.data.results
          const totalCount = resp.data.count
          if (totalCount % this.fetchCount == 0) {
            this.totalPage = totalCount/this.fetchCount
          } else {
            this.totalPage = totalCount/this.fetchCount + 1
          }
          this.totalPage = parseInt(this.totalPage)
          this.isFetching = false
        })
        .catch(() => {})
    },
  }
}
</script>

<style lang="scss" scoped>

</style>

<i18n>
{}
</i18n>
